<template>
  <div class="integral">
    <div class="header">
      <img class="bg" src="@/assets/person/dp-gr-jf2.png" />
      <div class="second-line">
        <i class="el-icon-back" @click="goBack"></i>
        <span>我的积分</span>
      </div>
      <div class="third-line">
        <p>
          {{firstName}}:
          <span>{{integral}}</span>
        </p>
        <p v-if="jurisdction" @click="toggle">
          {{secondName}}
          <img src="@/assets/person/dp-gr-jf1.png" alt />
        </p>
      </div>
      <div class="four-line">
        <button @click="goRecord">积分细则</button>
      </div>
      <div class="six-line">
        <div class="title">
          <img src="@/assets/person/dp-gr-jf3.1.png" alt />
          <span>积分明细</span>
        </div>
      </div>
    </div>

    <div class="content">
      <el-collapse v-model="activeName" accordion @change="change">
        <el-collapse-item
          :title="data.title"
          :name="index+'.'+data.title"
          v-for="(data,index) in datas"
          :key="index"
        >
          <div v-for="(detail,index) in detailData" :key="index">
            <span>{{detail.scoreDescrible}}</span>
            <span>{{detail.Addscore}}分</span>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: "1",
      datas: [{ title: "2019.02.03  当天积分:7" }],
      firstName: "我的个人积分",
      secondName: "党组织积分",
      integral: 0,
      time: "",
      detailData:[]
    };
  },
  mounted: function() {
    this.integral = this.$route.query.integral;
    this.getMsg();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goRecord() {
      if (this.firstName=="我的个人积分")
        this.$router.push({
          path: "/person/integral/integralrecord",
          query: { title: "个人积分说明" }
        });
      else
        this.$router.push({
          path: "/person/integral/integralrecord",
          query: { title: "党组织积分明细" }
        });
    },
    toggle() {
      let temp = this.firstName;
      this.firstName = this.secondName;
      this.secondName = temp;
      this.getMsg()
    },
    getMsg() {
      this.datas = [];
      this.axios
        .post("/api/Personal/Rank", {
          token: sessionStorage.getItem("token"),
          status: this.firstName=="我的个人积分"?0:1
        })
        .then(e => {
          this.datas=[]
          if (e.data.code == 0) {
             this.integral = e.data.count
            e.data.msg.filter(item => {
              this.datas.push({
                title: item.AddTime + " 当天积分:" + item.Addscore
              });
            });
          }
        });
    },
    getDetail() {
      this.axios.post("/api/Personal/Gettime", {
        token: sessionStorage.getItem("token"),
        status: this.firstName == "我的个人积分" ? 0 : 1,
        name:this.time
      }).then(e=>{        
        if(e.data.code==0){
          this.detailData = e.data.msg
        }
      })
    },
    change(e) {
      if (e != "") {
        let temp = e.split(".");
        let temp1 = temp[1].split(" ");
        this.time = temp1[0];
        this.getDetail()
      }
    }
  },
  computed: {
    jurisdction: function() {
      return sessionStorage.getItem("status") == "1" ? true : false;
    }
  }
};
</script>
<style lang='scss' scoped>
.integral {
  .content {
    .el-collapse {
      div {
        span {
          &:nth-child(1) {
            display: inline-block;
            width: 25%;
          }
          &:nth-child(2) {
            color: red;
          }
          font-size: 0.28rem;
        }
        color: #999999;
      }
      .is-active {
        font-weight: bold;
      }
      padding: 0 0.2rem;
    }
    background: #fff;
    padding-bottom: 1rem;
    width: 94%;
    margin: 0 auto;
    box-shadow: 1px 10px 10px 0px rgba(0, 0, 0, 0.1);
    border-bottom-left-radius: 0.16rem;
    border-bottom-right-radius: 0.16rem;
  }
  .header {
    .six-line {
      .title {
        img {
          width: 0.33rem;
          height: 0.33rem;
          margin-right: 0.2rem;
        }
        line-height: 3;
        padding: 0 2%;
        display: flex;
        align-items: center;
      }
      background: #fff;
      height: 1rem;
      position: absolute;
      bottom: 0rem;
      width: 94%;
      left: 3%;
      border-top-left-radius: 0.16rem;
      border-top-right-radius: 0.16rem;
    }
    .fif-line {
      div {
        p {
          width: 80%;
          height: 80%;
          color: #fff;
          background-image: linear-gradient(0deg, #fd5940 0%, #ffaa3e 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        display: inline-flex;
        align-items: center;
        border-radius: 50%;
        background: #fff;
        width: 2rem;
        height: 2rem;
        justify-content: center;
      }
      text-align: center;
      position: absolute;
      width: 100%;
      bottom: -0.8rem;
      z-index: 3;
    }
    .four-line {
      button {
        border-radius: 0.04rem;
        background-color: #ffffff;
        border: 0;
        padding: 0.1rem 0.2rem;
        color: #eb9739;
        font-size: 0.3rem;
        margin-right: 0.2rem;
      }
      position: absolute;
      top: 2.2rem;
      left: 0.2rem;
    }
    .third-line {
      p {
        &:nth-child(1) {
          span {
            font-size: 0.54rem;
            font-weight: bold;
          }
          border-bottom: 0.01rem solid #e6e6e6;
        }
        &:nth-child(2) {
          margin-left: auto;
          margin-right: 0.2rem;
        }
        line-height: 2;
      }
      img {
        width: 0.15rem;
        height: 0.21rem;
      }
      display: flex;
      align-items: center;
      color: #fff;
      position: absolute;
      top: 1rem;
      width: 94%;
      left: 3%;
    }
    .second-line {
      i {
        margin: 0 0.2rem;
      }
      position: absolute;
      display: flex;
      align-items: center;
      line-height: 2.5;
      position: fixed;
      width: 100%;
      z-index: 9;
      font-size: 0.36rem;
      color: #fff;
      width: 100%;
      top: 0rem;
    }
    .bg {
      width: 100%;
      height: 4.5rem;
      object-fit: cover;
    }
    position: relative;
  }
  min-height: 100vh;
  font-size: 0.3rem;
}
</style>

<style lang="scss">
.integral {
  .el-collapse {
    width: 94%;
    margin: 0 auto;
  }
  .el-collapse-item__header {
    font-size: 0.3rem;
  }
}
</style>